import type { ComicCard, ComicSource, ListOpts, SourceAuth } from '@/sources/types';

const MAX_FAVORITE_REFRESH_PAGES = 100;

export interface CollectedFavoriteCard {
  card: ComicCard;
  /**
   * Stable ordinal from the source-native favorites listing. Lower means the
   * source returned it earlier, which is usually newer in upstream UIs.
   */
  sourceOrder: number;
}

export async function collectFavoritePages(
  source: ComicSource,
  auth: SourceAuth,
): Promise<CollectedFavoriteCard[]> {
  if (!source.listFavorites) return [];

  const items: CollectedFavoriteCard[] = [];
  let opts: ListOpts = { page: 0 };
  for (let fetched = 0; fetched < MAX_FAVORITE_REFRESH_PAGES; fetched += 1) {
    const page = await source.listFavorites(auth, opts);
    for (const card of page.items) {
      items.push({ card, sourceOrder: items.length });
    }

    if (!page.hasMore) break;
    opts =
      page.nextCursor !== undefined
        ? { cursor: page.nextCursor }
        : { page: (opts.page ?? page.page) + 1 };
  }
  return items;
}
